import React from "react"

function ButtonIcon(props){
  const { icon } = props
  switch(icon) {
    case '':
      return ( null )
    default:
      return (
        <div className="buttonIcon">{props.icon}</div>
      )
  }
}

function ButtonTitle(props){
  const { title } = props
  switch(title) {
    case '':
      return ( null )
    default:
      return (
        <div className="buttonTitle">{props.title}</div>
      )
  }
}

export default function Button(props) {
  return (
    <div className={`button ${props.size} ${ props.color } ${ props.hierarchy } ${ props.state } ${ props.content }`} onClick={props.onClick}>
      <ButtonIcon icon={props.icon} />
      <ButtonTitle title={props.title} />
    </div>
  )
}
